import { jsx } from 'react/jsx-runtime';
import { faCircleQuestion } from '@optimizely/pro-light-svg-icons';
import PropTypes from 'prop-types';
import { Icon } from '../Icon/icon.js';
import OverlayWrapper from '../OverlayWrapper/index.js';
import Popover from '../Popover/index.js';

const HelpPopover = ({
  behavior,
  children,
  className,
  horizontalAttachment,
  iconSize = "small",
  isConstrainedToScreen,
  popoverTitle,
  testSection,
  verticalAttachment,
  ...props
}) => /* @__PURE__ */ jsx(
  OverlayWrapper,
  {
    behavior,
    className,
    horizontalAttachment,
    isConstrainedToScreen,
    overlay: /* @__PURE__ */ jsx(Popover, { testSection, title: popoverTitle, children }),
    testSection: `${testSection}-wrapper`,
    verticalAttachment,
    ...props,
    children: /* @__PURE__ */ jsx(
      "span",
      {
        className: "cursor--pointer push-half--left",
        "data-test-section": "help-popover-icon",
        children: /* @__PURE__ */ jsx(Icon, { icon: faCircleQuestion, size: iconSize })
      }
    )
  }
);
HelpPopover.propTypes = {
  /** Event to listen to and open the overlay */
  behavior: PropTypes.oneOf(["click", "hover"]),
  /** Description of thing that the person hovered for. */
  children: PropTypes.node.isRequired,
  /** CSS class names. */
  className: PropTypes.string,
  /** Side of the `overlay` that should attach to the `children` */
  horizontalAttachment: PropTypes.oneOf(["left", "center", "right"]),
  /** Size of icon */
  iconSize: PropTypes.oneOf(["small", "medium", "large"]),
  /** Attach `overlay` to an edge of the screen if it is going to move off */
  isConstrainedToScreen: PropTypes.bool,
  /** Title of thing that is being described. */
  popoverTitle: PropTypes.string,
  /** Test section */
  testSection: PropTypes.string,
  /** Vertical edge of the `overlay` that should touch the `children` */
  verticalAttachment: PropTypes.oneOf(["top", "middle", "bottom"])
};
HelpPopover.defaultProps = {
  behavior: "click",
  iconSize: "small",
  isConstrainedToScreen: true,
  testSection: "help-popover"
};

export { HelpPopover as default };
